
import { useParams } from "react-router-dom";
import Article from "./Article";

function ArticleHOC({

}) {

    const {slug} = useParams();

    return (
        <Article slug={slug} />
    );

}

export default ArticleHOC;